import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// Ready translated locale messages
const messages = {
  us: {
    app: {
      sent : "Sent",
      main_description : "Create and send your invoices and quotes online for free ! No Account Required",
      received : "Received",
      my_profile : "My Profile",
      update : "Update",
      send : "Send",
      mail_sent : "Mail sent",
      user_not_found : "There is no user record corresponding to this identifier. The user may have been deleted.",
      footer_text : "Please send us your feedback, we'd love to hear from you.",
      password : "Password",
      enter_password : "This invoice is marked as private please enter it's password then press enter.",
      search : "Search",
      signout : "Sign Out",
      dashboard : "Dashboard",
      register : "Sign Up",
      signin : "Sign In",
      forgot_password : "Forgot password ?",
      new_invoice :"New Invoice",
      email_already_in_use : "The email address is already in use by another account",
      wrong_password : "The password is invalid",
      your_logo : "Your logo",
      invoice_password : "Invoice Password",
      private : "Private",
      taxTypes: [
        {
          name: 'Rate',
          key: 'rate'
        },
        {
          name: 'Fixed Amount',
          key: 'amount'
        }

      ],
      amount : "Fixed Amount",
      amount_label : "Amount",
      rate : "Rate",
      main_title: "Create and send your invoices online",
      sub_title: "Fattoura is free",
      get_started: "Get Started",
      are_you_amazed: "Are you amazed? Stay tuned!",
      are_you_amazed_sub: "We are launching the beta in a few time.  If you want to be one of the first fattoura users we will email you as soon as we're ready. In the beginning only few people will test before the launch. Let us know how fattoura will help you!",
      get_in_touch: "Get in touch",
      copy: "Copy",
      share: "Share",
      share_message: "Please share this link with your client",
      preferred_language : "Preferred language",
      languages: ['us','fr'],
      profile_language : [
        {title  : "English" , key :"us"},
        {title  : "Frensh ", key : "fr"},
      ],
      your_company: 'Your Company',
      company_name: 'Company or full name',
      client_name: 'Client or full name',
      address: "Address",
      details: "Details",
      continue: "Continue",
      preview: "Preview",
      client: "Client",
      back: "Back",
      new_product: "New Product",
      new: "New",
      save: "Save",
      price: "Price",
      quantity: "Quantity",
      unit_price: "Unit Price",
      products: "Products",
      invoices_headers :[
        { text: "Action", value: "action" },
        { text: "Ref", value: "ref" },
        { text: "Date", value: "date" },
        { text: "Client", value: "client" },
        { text: "Sub Total", value: "sub_total" },
        { text: "Total", value: "total" },
        { text: "Currency", value: "currency" }
      ],
      products_headers: [
        { text: "Action", value: "action" },
        { text: "Ref", value: "ref" },
        { text: "Description", value: "name" },
        { text: "Quantity", value: "qty" },
        { text: "Rate/Price", value: "price" },
        { text: "Sub total", value: "sub_total" }
      ],
      taxes: "Taxes",
      new_tax: "New Tax",
      bill_to: "Bill to",
      number: "Number",
      invoice_info: "Invoice Info",
      invoice: "Invoice",
      date: "Date",
      due_date: "Due date",
      sub_total: "Sub total",
      total_tax: "Total taxes",
      total: "Total",
      type: "Type",
      currency: "Currency",
      invoice_types: ['Invoice', 'Quote'],
      description: "Description",
      name: "Name",
      close: "Close",
      taxes_headers: [
        { text: "Action", value: "action" },
        { text: "Description", value: "name" },
        { text: "Type", value: "type" },
        { text: "Rate/Amount", value: "amount" }
      ],
      home : "Home",
      terms : "Terms and Conditions",
      contact_us : "Contact Us",
      footerLinks :[
        { label: "Home", route: "/" },
        { label: "Terms and Conditions", route: "/terms" },
     //   { label: "Contact Us", route: "/contact" }
      ]
    }
  },
  fr: {
    app: {
      home : "Accueil" ,
      terms : "Termes et conditions",
      contact_us : "Contactez Nous",
      footerLinks :[
        { label: "Accueil", route: "/" },
        { label: "Termes et conditions", route: "/terms" },
     //   { label: "Contactez Nous", route: "/contact" }
      ],
      main_description : "Créez et envoyez vos factures et devis en ligne gratuitement! Aucun compte requis",
      sent : "Envoyé",
      received : "Reçu",
      my_profile : "Mon Profile",
      update : "Mettre à jour",
      user_not_found : "Aucun  utilisateur ne correspond à cet identifiant. L'utilisateur a peut-être été supprimé.",
      send : "Envoyer",
      mail_sent : "Mail envoyé",
      footer_text : "Veuillez nous envoyer vos suggestions, nous aimerions avoir de votre avis.",
      enter_password : "Cette facture est marquée comme privée, veuillez saisir son mot de passe, puis appuyez sur Entrée.",
      password : "Mot de passe",
      search : "Recherche",
      signout : "Déconnexion",
      dashboard : "Tableau de bord",
      register : "S'inscrire",
      signin : "Se connecter",
      forgot_password : "Mot de passe oublié ?",
      new_invoice :"Nouvelle facture",
      wrong_password : "Mot de passe invalide",
      email_already_in_use : "L'adresse e-mail est déjà utilisée par un autre compte",
      your_logo : "Votre logo",
      invoice_password : "Mot de passe",
      private : "Privée",
      taxTypes: [
        {
          name: 'Taux',
          key: 'rate'
        },
        {
          name: 'Montant fixe',
          key: 'amount'
        }

      ],
      amount : "Montant fixe",
      amount_label : "Montant",
      rate : "Taux",
      main_title: "Envoyez des factures professionnelles en deux minutes",
      sub_title: "Fattoura est gratuit",
      get_started: "Commencer gratuitement",
      are_you_amazed: "Restez à l'écoute!",
      are_you_amazed_sub: "nous lançons la bêta dans quelques temps. Si vous souhaitez être l'un des premiers utilisateurs de fattoura, nous vous enverrons un e-mail dès que nous serons prêts. Au début, seules quelques personnes testeront avant le lancement. Faites-nous savoir comment la fattoura vous aidera!",
      get_in_touch: "Souscrire",
      copy: "Copier",
      share: "Partager",
      share_message: "Veuillez partager ce lien avec votre client",
      languages: ['us','fr'],
      preferred_language : "Langue préférée",
      profile_language : [
        {title  : "Anglais" , key :"us"},
        {title  : "Français", key : "fr"},
      ],
      your_company: 'Votre entreprise',
      company_name: 'Société ou nom complet',
      client_name: 'Client ou nom complet',
      address: "Adresse",
      details: "Détails",
      continue: "Continuer",
      preview: "Aperçu",
      client: "Client",
      back: "Retour",
      new_product: "Nouveau produit",
      new: "Nouveau",
      save: "Sauvegarder",
      price: "Prix",
      quantity: "Quantité",
      unit_price: "Prix unitaire",
      products: "Produits",
      invoices_headers :[
        { text: "Action", value: "action" },
        { text: "Ref", value: "ref" },
        { text: "Date", value: "date" },
        { text: "Client", value: "client" },
        { text: "Sous-total", value: "sub_total" },
        { text: "Total", value: "total" },
        { text: "Devise", value: "currency" }
      ],
      products_headers: [
        { text: "Action", value: "action" },
        { text: "Ref", value: "ref" },
        { text: "Description", value: "name" },
        { text: "Quantité", value: "qty" },
        { text: "Tarif / Prix", value: "price" },
        { text: "Sous-total", value: "sub_total" }
      ],
      taxes: "Taxes",
      new_tax: "Nouvelle taxe",
      bill_to: "Facturé à",
      number: "numéro",
      invoice_info: "Info facture",
      invoice: "Facture",
      date: "Date",
      due_date: "Date d'échéance",
      sub_total: "Sous-total",
      total_tax: "Total taxes",
      total: "Total",
      type: "Type",
      currency: "Devise",
      description: "Description",
      name: "Nom",
      invoice_types: ['Facture', 'Devis'],
      close: "Fermer",
      taxes_headers: [
        { text: "Action", value: "action" },
        { text: "Description", value: "name" },
        { text: "Type", value: "type" },
        { text: "Taux/Prix", value: "amount" }
      ]
    }
  }
}

const i18n = new VueI18n({
  locale: 'us', // set locale
  fallbackLocale: 'us', // set fallback locale
  messages, // set locale messages
});


export default i18n;